import { Schedule }   from "../../planner_base";
import { Global, CellPosition, LineSelectedSchedule }  from "../model";
import {
  PLANNER_CLICK_START_LEFT,
  PLANNER_CLICK_START_RIGHT,
  PLANNER_CLICK_END_LEFT,
  PLANNER_CLICK_END_RIGHT,
  PLANNER_DRAG_START,
  PLANNER_DRAG_END
} from 'apps/events';
import Timelag from 'utilities/timelag';
import { MouseDragUtil, IMouseDragUtilOptions } from 'utilities/mouse/drag_util';
import { SchedulesCell } from './schedules-cell';

class SchedulesExpander extends Schedule {
  selected: boolean = false;
  lagClickLeft: Timelag;
  lagClickRight: Timelag;
  clickLeftEvent: string;
  clickRightEvent: string;
  dragEvent: string;
  dragUtil: MouseDragUtil;
  dragUtilOptions: IMouseDragUtilOptions;
  schedulesCell: SchedulesCell;
  mouseDownTime: number;
  init(){
    super.init();
    this.watch();
    this.schedulesCell = this.parent as any;
    this.watchPlannerData('selectedSchedule', (newVal: any, oldVal: any, objectPath: string) => { this.onChangeSelectedSchedule(newVal, oldVal, objectPath)});
    this.lagClickLeft = new Timelag(()=>{ this.onClickLeftDo(); }, 250);
    this.lagClickRight = new Timelag(()=>{ this.onClickRightDo(); }, 250);
  }
  onChangeSelectedSchedule(selectedSchedule: LineSelectedSchedule, oldVal, objectPath) {
    this.onSelectedSchedule(selectedSchedule);
  }
  onSelectedSchedule(selectedSchedule){
    if(selectedSchedule == null || selectedSchedule.scheduleId != this.opts.id){
      this.unSelect();
    } else {
      this.select(selectedSchedule);
    }
  }
  unSelect(){
    if(!this.selected){ return; }
    this.selected = false;
    this.update();
  }
  select(selectedSchedule: LineSelectedSchedule){
    this.selected = true;
    this.update();
  }
  onClickLeft(e){
    e.preventUpdate = true;
    if(this.opts.updating){ return false; }
    if(Date.now() - this.mouseDownTime > 500){ return; }
    this.lagClickLeft.start();
  }
  onClickLeftDo(){
    let clickNum = this.lagClickLeft.number();
    let e = new CustomEvent(this.clickLeftEvent, { detail: {scheduleId: this.opts.id, clickNum: clickNum } });
    document.dispatchEvent(e);
  }
  onClickRight(e){
    e.preventUpdate = true;
    if(this.opts.updating){ return false; }
    if(Date.now() - this.mouseDownTime > 500){ return; }
    this.lagClickRight.start();
  }
  onClickRightDo(){
    let clickNum = this.lagClickRight.number();
    let e = new CustomEvent(this.clickRightEvent, { detail: {scheduleId: this.opts.id, clickNum: clickNum } });
    document.dispatchEvent(e);
  }
  onDown(mouseEvent){
    mouseEvent.preventUpdate = true;
    if(this.opts.updating){ return false; }
    this.mouseDownTime = Date.now();
    this.dragUtilOptions = {
      onDrag: () => { this.onDragging() },
      onEnd: () => { this.onEndDrag() },
      unitX: Global.getCellWidth(),
      unitY: 0
    };
    this.dragUtil = new MouseDragUtil(mouseEvent, this.dragUtilOptions);
  }
  onDragging(){
  }
  onEndDrag(){
    let stepX = this.dragUtil.pos().stepX;
    let e = new CustomEvent(this.dragEvent, { detail: {stepX: stepX, scheduleId: this.opts.id } });
    document.dispatchEvent(e);
    this.dragUtil = undefined;
  }
}

export class SchedulesLeft extends SchedulesExpander {
  init(){
    super.init()
    this.clickLeftEvent = PLANNER_CLICK_START_LEFT;
    this.clickRightEvent = PLANNER_CLICK_START_RIGHT;
    this.dragEvent = PLANNER_DRAG_START;
  }
  onDragging(){
    let stepX = this.dragUtil.pos().stepX;
    this.schedulesCell.resetPosition(stepX, 0);
  }
}
export class SchedulesRight extends SchedulesExpander {
  init(){
    super.init()
    this.clickLeftEvent = PLANNER_CLICK_END_LEFT;
    this.clickRightEvent = PLANNER_CLICK_END_RIGHT;
    this.dragEvent = PLANNER_DRAG_END;
  }
  onDragging(){
    let stepX = this.dragUtil.pos().stepX;
    this.schedulesCell.resetPosition(0, stepX);
  }
}
riot.mixin('orders.planner.line-ui.schedules-left', SchedulesLeft as riot.TagMixin)
riot.mixin('orders.planner.line-ui.schedules-right', SchedulesRight as riot.TagMixin)
